// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller.coffee"
application.register("hello", HelloController)

import CoffeeHelloController from "./coffee_hello_controller.coffee"
application.register("coffee-hello", CoffeeHelloController)

import SearchFormController from "./search_form_controller.coffee"
application.register("search-form", SearchFormController)

import LayoutPreviewController from "./layout_preview_controller"
application.register("layout-preview", LayoutPreviewController)
